import { Location } from "history";
import { OrderData } from "../../../../../services/Api/Public/types";

export const getOrderBackRedirect = (matchUrl: string, order: OrderData | undefined, location: Location<unknown>) => {
	const pathname = location.pathname;

	if (pathname.includes("custom_tip")) {
		return `${matchUrl}/tip`;
	}
	if (pathname.includes("tip")) {
		return matchUrl;
	}
	if (pathname.includes("payment")) {
		if (!order?.tip_available) {
			return matchUrl;
		}
		return `${matchUrl}/tip`;
	}
	return matchUrl;
};
